/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_08a99fd2"]'><div :class='["checkbox-group-round-demo"]'><div :class='["cube-checkbox-group-example"]'><cube-checkbox-group :options="(options)" :values="checkedValues" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValues", "__mpx_event__", ["value"], undefined]])' @checked='(e)=>__invoke(e, [["onChecked"]])' @cancelChecked='(e)=>__invoke(e, [["onCancelChecked"]])'></cube-checkbox-group></div><div :class='["view-desc"]'>checked values：{{ checkedValues }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_08a99fd2"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_08a99fd2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_08a99fd2"}
  /** script content **/
  require("./round.mpx.js?isComponent&outputPath=components%2Fround08a99fd2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./round.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fround08a99fd2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_08a99fd2"],
    ctorType: "component",
    outputPath: "components/round08a99fd2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-group/index.mpx?isComponent&outputPath=components%2Findexc8b9c288%2Findex")),'cube-checkbox':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>